<template>
  <c-modal-form
    :id="$getConst('FORM_CALL_ORDER_MODAL_ID')"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    :error="error"
    fields-required
    title="Заказать звонок"
    @submit="submit()"
  >
    <form>
      <c-input
        v-model="name"
        form-group
        placeholder="*Имя"
      />
      <c-input
        v-model="phone"
        form-group
        :input-mask="$getConst('PHONE_INPUT_MASK')"
        placeholder="*Телефон"
      />
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CInput from '../../../../../../../resources/js/components/ui/CInput'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import apiService from '../../apiService'
import { mapGetters, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно "Заказать звонок".
 */
export default {
  name: 'CallOrder',
  components: {
    CModalForm,
    CInput,
    DemoDenied
  },
  mixins: [form, modal],
  data: () => {
    return {
      name: '',
      phone: ''
    }
  },
  computed: {
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.clientDomainsFetching || this.sending)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.domainSelected && this.name && this.phone && this.phone.match(/[0-9]/g).length === 11 && !this.isDemo)
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      clientDomainsFetching: state => state.seo.client.domains.fetching
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  mounted () {
    $(`#${this.$getConst('FORM_CALL_ORDER_MODAL_ID')}`).on('hidden.bs.modal', () => {
      this.resetState()
    })
  },
  methods: {
    /**
     * Сбрасывает данные формы.
     */
    resetState () {
      this.name = ''
      this.phone = ''
    },
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      apiService.postFormsCallOrder(this.domainSelected, this.name, this.phone)
        .then(() => {
          this.hideModal(this.$getConst('FORM_CALL_ORDER_MODAL_ID'))
          this.resetState()

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    }
  }
}
</script>
